<template lang="pug">
  .component-tabbed-vehicle-costs
    CreateNoteModal(:entity="note.type", :entityId="$route.params.id", @noteCreated="$refs.notesBaseList.loadData(1)")
    .container
      base-list(
        :component="component",
        :dataLoader="dataLoader",
        :showPerPageSelect="false",
        ref="notesBaseList",
        component-type="entityList"
      )
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice"
  import BaseList from '../../../pages/backoffice/BaseList'
  import CreateNoteModal from "../../../pages/backoffice/CreateNoteModal";

  export default {
    name: "ReservationNotes",
    components: {BaseList, CreateNoteModal},
    data() {
      return {
        note: {type: 'App\\Models\\Reservation', id: null, description: null},
        component: require('src/components/backoffice/Note'),
      }
    },
    methods: {
      dataLoader(callback, page = 1, resultsPerPage = 25) {
        KeplerBackofficeSdk.notes.list().all({
          per_page: resultsPerPage,
          page_number: page,
          type: 'App\\Models\\Reservation',
          id: this.$route.params.id
        }, (data) => {
          callback(data)
        })
      },
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
.component-tabbed-vehicle-costs
  width: 100%
  padding-bottom: 25px

  .container
    margin: 20px

  .roi
    .inner-content
      padding-top: 0
</style>



// WEBPACK FOOTER //
// ReservationNotes.vue?a9c4e206